module.exports = __webpack_public_path__ + "img/hemline_sweep.c00f5408.png";